module.exports = __webpack_public_path__ + "img/commerce-and-shopping.63c0341c.png";